import { styled } from '~/styled'

export const Flex = styled(
  'div',
  {
    base: ['flex'],
    variants: {
      direction: {
        row: ['flex-row'],
        'row-reverse': ['flex-row-reverse'],
        column: ['flex-col'],
        'column-reverse': ['flex-col-reverse'],
        inherit: ['direction-[inherit]'],
        initial: ['direction-[initial]'],
        revert: ['direction-[revert]'],
        'revert-layer': ['direction-[revert-layer]'],
        unset: ['direction-[unset]']
      },
      wrap: {
        nowrap: ['flex-nowrap'],
        wrap: ['flex-wrap'],
        'wrap-reverse': ['flex-wrap-reverse'],
        inherit: ['[flex-wrap:inherit]'],
        initial: ['[flex-wrap:initial]'],
        revert: ['[flex-wrap:revert]'],
        'revert-layer': ['[flex-wrap:revert-layer]'],
        unset: ['[flex-wrap:unset]']
      },
      justify: {
        normal: ['justify-normal'],
        unsafe: ['[justify-content:unsafe]'],
        safe: ['[justify-content:safe]'],
        start: ['justify-start'],
        center: ['justify-center'],
        end: ['justify-end'],
        'flex-start': ['justify-start'],
        'flex-end': ['justify-end'],
        left: ['[justify-content:left]'],
        right: ['[justify-content:right]'],
        'space-between': ['justify-between'],
        'space-around': ['justify-around'],
        'space-evenly': ['justify-evenly'],
        stretch: ['justify-stretch'],
        inherit: ['[justify-content:inherit]'],
        initial: ['[justify-content:initial]'],
        revert: ['[justify-content:revert]'],
        'revert-layer': ['[justify-content:revert-layer]'],
        unset: ['[justify-content:unset]']
      },
      align: {
        normal: ['[align-items:normal]'],
        unsafe: ['[align-items:unsafe]'],
        safe: ['[align-items:safe]'],
        center: ['items-center'],
        start: ['items-start'],
        end: ['items-end'],
        'self-start': ['[align-items:self-start]'],
        'self-end': ['[align-items:self-end]'],
        'flex-start': ['items-start'],
        'flex-end': ['items-end'],
        baseline: ['items-baseline'],
        'first baseline': ['[align-items:first baseline]'],
        'last baseline': ['[align-items:last baseline]'],
        stretch: ['items-stretch'],
        inherit: ['[align-items:inherit]'],
        initial: ['[align-items:initial]'],
        revert: ['[align-items:revert]'],
        'revert-layer': ['[align-items:revert-layer]'],
        unset: ['[align-items:unset]']
      },
      gap: {
        0: ['gap-0.5'],
        1: ['gap-1'],
        2: ['gap-2'],
        3: ['gap-3'],
        4: ['gap-4'],
        24: ['gap-6'],
        5: ['gap-8'],
        6: ['gap-10'],
        7: ['gap-12'],
        8: ['gap-16'],
        9: ['gap-20']
      }
    }
  },
  { enabledResponsiveVariants: true }
)

Flex.displayName = 'Flex'
